import styled from "@emotion/styled";
import { colors, radius, spacing } from "../design-tokens";

export type ActionButtonProps = {
  variant?: "primary" | "secondary" | "ghost";
  size?: "small" | "medium";
  isActive?: boolean;
};

const variantStyles = {
  primary: {
    background: colors.primaryButton,
    color: colors.white,
    border: "none",
    hover: {
      background: colors.primaryButtonHover,
    },
  },
  secondary: {
    background: colors.surface,
    color: colors.text,
    border: `1px solid ${colors.border}`,
    hover: {
      background: colors.border,
    },
  },
  ghost: {
    background: "transparent",
    color: colors.text,
    border: "none",
    hover: {
      background: colors.surface,
    },
  },
};

export const ActionButton = styled.button<ActionButtonProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${spacing.xs}px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  border-radius: ${radius.sm}px;
  cursor: pointer;
  transition: all 200ms ease-in-out;
  flex-shrink: 0;
  
  /* Size variants */
  padding: ${(props) => {
    return props.size === "small"
      ? `${spacing.sm}px ${spacing.sm}px`
      : `${spacing.sm}px ${spacing.md}px`;
  }};
  
  /* Apply variant styles */
  ${(props) => {
    const variant = props.variant || "ghost";
    const styles = variantStyles[variant];

    return `
      background: ${props.isActive ? colors.activeAlternative : styles.background};
      color: ${styles.color};
      border: ${styles.border};
    `;
  }}
  
  &:hover:not(:disabled) {
    ${(props) => {
      const variant = props.variant || "ghost";
      const styles = variantStyles[variant];

      return `
        background: ${props.isActive ? colors.accentSoft : styles.hover.background};
      `;
    }}
  }
    
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  /* Icon support */
  svg {
    width: 16px;
    height: 16px;
  }
`;
